import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Flow, FlowFetchResponse} from '../_services/Flow';

type PageProps = {};

export const Page: React.FunctionComponent<PageProps> = ({}) => {
    const {slug} = useParams();
    const [pageContent, setPageContent] = useState<string>('');

    useEffect(() => {
        Flow.getInstance().getPageForSlug(slug)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setPageContent(response.json.content);
                } else {
                    throw Error(response?.json?.message || 'Page not found');
                }
            })
            .catch((error: any) => {
                console.log(error?.message || error || 'Page not found');
            })
            .finally(() => {

            });
    }, [slug]);

    return (
        <div dangerouslySetInnerHTML={{__html: pageContent}} />
    );
};